import { Component, OnInit } from '@angular/core';
export class LeftSideComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'hd-left-side',
  template: `
    <ng-content></ng-content>
  `,
  styles: [`
    :host {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-flex: 50%;
          -ms-flex: 50%;
              flex: 50%;
      border: none;
      height: 100vh; }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function LeftSideComponent_tsickle_Closure_declarations() {
/** @type {?} */
LeftSideComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LeftSideComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
